import { OddsAcceptanceMode } from '@bpos';
import { OddsComparer } from '@frontend/sports/odds/feature';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Action } from '@ngrx/store';

import { BetslipPick } from '../../../core/picks/betslip-pick';
import { PriceType } from '../../../core/picks/pick-models';
import BetslipErrorsActions from '../../validation/actions';
import BetslipPickActions from '../actions';

export default class AcceptCurrentPriceHelper {
    static getAcceptPriceActions(
        picks: BetslipPick[],
        oddAcceptance: OddsAcceptanceMode,
        oddsFormat: OddsDisplayFormat,
        isManual: boolean,
        bypassErrorClear: boolean,
    ): Action[] {
        const actions: Action[] = [];
        for (const pick of picks) {
            const price = pick.currentPrice;
            if (price && price.type === PriceType.Fixed) {
                const acceptedPrice = pick.acceptedPrice.price;
                const oddsComparer = new OddsComparer(price.nativeOdds, oddsFormat);
                // noinspection OverlyComplexBooleanExpressionJS
                if (
                    oddAcceptance === OddsAcceptanceMode.Any ||
                    (oddAcceptance === OddsAcceptanceMode.Higher && (!acceptedPrice || oddsComparer.greaterThan(acceptedPrice.nativeOdds)))
                ) {
                    actions.push(
                        BetslipPickActions.acceptCurrentPrice({
                            pickIds: [pick.id],
                            isManuallyAccepted: isManual,
                        }),
                    );
                }
            }
        }

        // Clear OverallMaxWinPerUserExceededError on pick update
        if (!bypassErrorClear) {
            actions.push(BetslipErrorsActions.removeOverallMaxWinPerUserExceededError());
        }

        return actions;
    }
}
